<section class="flex w-full justify-end gap-4 pr-8 text-white">
  @if (!pieChartData?.datasets?.[0]?.data?.length) {
    <div class="flex items-center justify-center">
      @if (isLoading) {
        <div class="loading-spinner">
          <mat-spinner [diameter]="50"></mat-spinner>
        </div>
      } @else {
        <svg width="400" height="250px">
          <circle
            cx="200"
            cy="125"
            r="115"
            class="fill-black/10 stroke-gray-300 stroke-2 drop-shadow"
          ></circle>

          <text
            x="200"
            y="125"
            font-size="15"
            text-anchor="middle"
            fill="#ffffff"
          >
            No tickets for given time range
          </text>
        </svg>
      }
    </div>
  } @else {
    <div class="flex w-[350px] items-center justify-center">
      <canvas
        class="drop-shadow"
        baseChart
        [data]="pieChartData"
        [options]="pieChartOptions"
        [labels]="pieChartData.labels"
        [type]="pieChartType"
      ></canvas>
    </div>
  }

  <!-- Right: CTA -->
  <div class="self-end text-right font-montserrat">
    <a
      routerLink="/tickets/insights"
      class="flex items-center justify-end gap-1 text-base font-medium text-white transition-opacity hover:opacity-75"
    >
      View ticket insights
      <mat-icon class="text-base">arrow_forward</mat-icon>
    </a>
    <p class="mt-1 text-xs text-white/40">
      Trends, performance, and key metrics
    </p>
  </div>
</section>
